export default [
	{
		type: 'item',
		slug: 'health-potion',
		targets: [ 'empty' ],
		levels: [
			{ life: 1 },
			{ life: 2 },
			{ life: 3 },
		],
		fr: {
			name: "Potion de soin",
			description: "Soigne (X) point(s) de vie."
		},
		en: {
			name: "Healing Potion",
			description: "Heals (X) health point(s)."
		}
	},
	{
		type: 'item',
		slug: 'poison-potion',
		targets: [ 'empty' ],
		levels: [
			{ poison: 1 },
			{ poison: 2 },
			{ poison: 3 },
		],
		fr: {
			name: "Potion de poison",
			description: "Inflige (poison (X))[status-poison:(X)]."
		},
		en: {
			name: "Potion of Poison",
			description: "Inflicts (poison (X))[status-poison:(X)]."
		}
	},
	{
		type: 'item',
		slug: 'strength-potion',
		targets: [ 'empty' ],
		levels: [
			{ strength: 1 },
			{ strength: 2 },
			{ strength: 3 },
		],
		fr: {
			name: "Potion de force",
			description: "Confère (force (X))[status-strength:(X)]."
		},
		en: {
			name: "Potion of Strength",
			description: "Gives  (strength (X))[status-strength:(X)]."
		}
	},
	{
		type: 'item',
		slug: 'weakness-potion',
		targets: [ 'empty' ],
		levels: [
			{ weakness: 1 },
			{ weakness: 2 },
			{ weakness: 3 },
		],
		fr: {
			name: "Potion de faiblesse",
			description: "Inflige (faiblesse (X))[status-weakness:(X)]."
		},
		en: {
			name: "Potion of Weakness",
			description: "Inflicts (weakness (X))[status-weakness:(X)]."
		}
	},
	{
		type: 'item',
		slug: 'feather',
		value: null,
		targets: [ 'empty' ],
		fr: {
			name: "Plume",
			description: "Pousse l'ennemi adjacent."
		},
		en: {
			name: "Feather",
			description: "Pushes the adjacent enemy."
		}
	},
]